<template>
  <div class="box-father">
    <div class="box-header">
      <div class="box-header-left">
        <div class="box-header-left-text">认证权限 /</div>
        <div class="box-header-right"><div>菜单管理</div></div>
      </div>
    </div>
    <div class="section" v-if="st == 1">
      <div class="biaodan">
        <div class="botton-box">
          <el-button
            size="mini"
            class="addButton"
            @click="getchildeditDialog(0)"
            >添加</el-button
          >
          <el-button class="enableButton" size="mini" @click="enableMenu"
            >启用</el-button
          >
          <el-button type="danger" size="mini" @click="disableMenu"
            >停用</el-button
          >
        </div>
        <div class="biaodan-left">
          <div style="height: 100%">
            <el-form
              :inline="true"
              label-position="right"
              class="demo-form-inline"
              :model="form"
            >
              <el-form-item label="菜单名称">
                <el-input
                  v-model="form.name"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入菜单名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="菜单路径">
                <el-input
                  v-model="form.url"
                  clearable
                  style="width: 150px"
                  size="mini"
                  placeholder="请输入菜单路径"
                ></el-input>
              </el-form-item>
              <el-form-item label="菜单状态">
                <el-select
                  style="width: 150px"
                  size="mini"
                  placeholder="请选择菜单状态"
                  clearable
                  v-model="form.status"
                  filterable
                >
                  <el-option
                    v-for="item in roleTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="form-item">
                <el-button
                  type="primary"
                  @click="onSearch"
                  class="search"
                  size="mini"
                  >查询</el-button
                >
                <el-button
                  type="primary"
                  @click="onReset"
                  class="search"
                  size="mini"
                  >重置</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="aside">
        <el-row>
          <el-col :span="24">
            <el-table
              class="table_name"
              highlight-current-row
              ref="LoadTable"
              :data="tableData"
              row-key="uuid"
              border
              :header-cell-style="{
                background: '#F3F8FE',
                color: '#333333',
                textAlign: 'center'
              }"
              :cell-style="cellStyle"
              lazy
              :load="treeLoadSon"
              @selection-change="handleSelectionChange"
              :tree-props="{ children: 'children', hasChildren: 'haveSon' }"
              max-height="650"
              @select="handleSelect"
              @select-all="selectAll"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="menuName" label="菜单名称">
                <template slot-scope="scope">
                  <div v-if="scope.row.data.menuName">
                    {{ scope.row.data.menuName }}
                  </div>
                  <div v-else>{{ scope.row.data.menuName }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="menuUrl" label="菜单路径">
                <template slot-scope="scope">
                  <div v-if="scope.row.data.menuUrl">
                    {{ scope.row.data.menuUrl }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="menuUrl" label="菜单编码">
                <template slot-scope="scope">
                  <div v-if="scope.row.data.menuCode">
                    {{ scope.row.data.menuCode }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="类型">
                <template slot-scope="scope">
                  <div v-if="scope.row.type == 1">菜单</div>
                  <div v-if="scope.row.type == 2">按钮</div>
                  <div v-if="scope.row.type == 3">页面</div>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="状态">
                <template slot-scope="scope">
                  <div v-if="scope.row.status == 1">启用</div>
                  <div v-else>停用</div>
                </template>
              </el-table-column>
              <el-table-column prop="status" label="备注">
                <template slot-scope="scope">
                  <div>{{ scope.row.data.remark }}</div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="360">
                <template slot-scope="scope">
                  <el-button
                    style="margin-left: 10px;color:#3666EA"
                    type="text"
                    @click="getValueDialog(0, scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    style="margin-left: 10px;color:#3666EA"
                    type="text"
                    @click="getchildeditDialog(1, scope.row)"
                    >添加子菜单</el-button
                  >
                  <!-- <el-button
                    style="margin-left: 10px;color:#3666EA"
                    type="text"
                    @click="addResources(scope.row)"
                  >资源管理</el-button> -->
                  <el-popconfirm
                    title="确定删除吗？"
                    trigger="click"
                    @confirm="deleteType(scope.row)"
                  >
                    <el-button
                      style="margin-left: 10px;color:#ED6363"
                      type="text"
                      slot="reference"
                      >删除</el-button
                    >
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
            :page-size="page.size"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            :current-page.sync="currentPage"
            :style="{ textAlign: 'right', marginTop: '20px' }"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="800px"
      :modal="true"
      :close-on-click-modal="false"
    >
      <div>
        <el-form
          :model="formData"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
        >
          <el-form-item prop="menuName" label="菜单名称">
            <el-input
              v-model="formData.menuName"
              placeholder="菜单名称"
            ></el-input>
          </el-form-item>
          <el-form-item prop="menuUrl" label="菜单路由">
            <el-input
              v-model="formData.menuUrl"
              placeholder="菜单路由"
            ></el-input>
          </el-form-item>
          <el-form-item prop="menuCode" label="菜单编码">
            <el-input
              :disabled="iscode"
              v-model="formData.menuCode"
              placeholder="菜单编码"
            ></el-input>
          </el-form-item>
          <el-form-item prop="appId" label="所属应用" v-if="this.sts == 0">
            <el-select
              v-model="formData.appId"
              placeholder="请选择应用类型"
              filterable
            >
              <el-option
                v-for="(item, index) in appTypeList"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="orderNo" label="排序">
            <el-input
              v-model="formData.orderNo"
              type="number"
              placeholder="排序"
            ></el-input>
          </el-form-item>
          <el-form-item label="菜单状态" prop="superAdmin">
            <el-radio-group size="mini" v-model="formData.status">
              <el-radio
                v-for="dict in roleTypeList"
                :key="dict.label"
                :value="dict.value"
                :label="dict.value"
                >{{ dict.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="是否菜单" prop="superAdmin">
            <el-radio-group size="mini" v-model="formData.menu">
              <el-radio
                v-for="dict in menuType"
                :key="dict.label"
                :disabled="isMenu"
                :value="dict.value"
                :label="dict.value"
                >{{ dict.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <!-- <el-form-item label="菜单图标">
            <el-upload class="avatar-uploader" :action="imgUploadUrl" :headers="headers" :data="{ isUniqueKey: true }" :on-preview="handlePreview" :on-remove="handleRemove" :on-success="getImgInfo" :on-exceed="getExceed" :file-list="fileList" :limit="1" list-type="picture" :before-upload="beforeAvatarUpload">
              <el-button size="mini" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png/svg文件，且不超过2mb
              </div>
            </el-upload>
          </el-form-item> -->
          <el-form-item label="备注">
            <el-input type="textarea" v-model="formData.remark"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          class="search"
          size="mini"
          @click="cancelcerat"
        >
          <span>确 定</span>
        </el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="菜单资源"
      :close-on-click-modal="false"
      :visible.sync="UserGroupVisible"
    >
      <div class="Group-search">
        <div class="Group-search-input">
          <el-form
            :inline="true"
            label-position="right"
            class="demo-form-inline"
            :model="resources"
          >
            <el-form-item label="资源编码">
              <el-input
                v-model="resources.resourceCode"
                clearable
                style="width: 150px"
                size="mini"
                placeholder="请输入资源编码"
              ></el-input>
            </el-form-item>
            <el-form-item label="资源类型">
              <el-select
                style="width: 150px"
                size="mini"
                placeholder="请选择资源类型"
                clearable
                v-model="resources.resourceType"
                filterable
              >
                <el-option
                  v-for="item in resourceTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button
                type="primary"
                @click="onresources"
                class="search"
                size="mini"
                >查询</el-button
              >
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="Group-button">
        <el-button size="mini" type="primary" @click="add()">创建</el-button>
        <el-button size="mini" type="danger" @click="deleteResources()"
          >去除删除</el-button
        >
      </div>
      <div class="aside">
        <el-row>
          <el-col :span="24">
            <el-table
              class="disTable"
              ref="multipleTable"
              align="center"
              max-height="650"
              :header-cell-style="{
                background: '#F3F8FE',
                color: '#333333 ',
                textAlign: 'center'
              }"
              :cell-style="{ textAlign: 'center' }"
              :data="resourcesList"
              @selection-change="SelectionChangeResources"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                align="center"
                prop="resourceCode"
                label="资源编码"
                width="200"
              ></el-table-column>
              <el-table-column prop="resourceType" label="资源类型">
                <template slot-scope="scope">
                  <div v-if="scope.row.resourceType == 1">按钮</div>
                  <div v-else>页面</div>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="remark"
                label="备注"
              ></el-table-column>
              <el-table-column align="center" prop="remark" label="操作">
                <template slot-scope="scope">
                  <el-button
                    style="margin-left: 10px;color:#3666EA"
                    type="text"
                    @click="editResources(scope.row)"
                    >编辑</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChangeOne"
            layout="total, sizes, prev, pager, next, jumper"
            :total="resourcesPage.total"
            background
            :page-size="resourcesPage.size"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChangeOne"
            :current-page.sync="currentPageOne"
            :style="{ textAlign: 'right', marginTop: '20px' }"
          ></el-pagination>
        </div>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        title="创建资源"
        class="user-dialog"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="aside">
          <el-form
            :model="resourcesFormData"
            :rules="rules"
            :inline="true"
            ref="formInbasic"
            class="basic_form"
          >
            <el-form-item prop="resourceCode" label="资源编码">
              <el-input
                v-model="resourcesFormData.resourceCode"
                placeholder="资源编码"
              ></el-input>
            </el-form-item>
            <el-form-item label="资源类型" prop="superAdmin">
              <el-radio-group
                size="mini"
                v-model="resourcesFormData.resourceType"
              >
                <el-radio
                  v-for="dict in resourceTypeList"
                  :key="dict.label"
                  :value="dict.value"
                  :label="dict.value"
                  >{{ dict.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="resourcesFormData.remark"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible = false">取 消</el-button>
          <el-button
            type="primary"
            class="search"
            size="mini"
            @click="Setresources"
          >
            <span>确 定</span>
          </el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>
<script>
import {
  getMenuList,
  setMenuSave,
  setRoleGrant,
  setMenuTree,
  getRoleArray,
  setMenuSwitch,
  getAppArray,
  getMenuResource,
  setMenuSaveResource,
  setMenuDeleteResource
} from "@/api/systemManagement";
import { getMenuRoot, userType } from "../../../api/systemManagement";
export default {
  data() {
    return {
      maps: new Map(),
      headers: {
        // token: this.$store.state.token,
        STORE_BUCKET_KEY: "zkwg-f57a56d8"
      },
      iscode: false,
      isMenu: true,
      imgUploadUrl: null,
      UserGroupVisible: false,
      visible: false,
      currentPageOne: "1",
      innerVisible: false,
      resourcesList: [],
      deptTree: [],
      roleValue: [],
      DepartmentList: [],
      tableDataTwo: [],
      roleList: [],
      roleData: [],
      isformPermission: false,
      dialogVisibleTwo: false,
      currentPageTwo: "1",
      relationUser: false,
      dialogVisible: false,
      passwordVisible: false,
      st: 1,
      formPermission: {
        id: null,
        roleIds: []
      },
      havePermIds: [],
      totalTwo: "",
      superAdminList: [{ value: 1, label: "是" }, { value: 0, label: "否" }],
      defaultProps: {
        children: "children",
        label: "label"
      },
      roleTypeList: [{ value: 1, label: "启用" }, { value: 0, label: "停用" }],
      ruleForm: {
        accountName: "",
        userName: "",
        password: "",
        deptId: "",
        userType: 1,
        phone: "",
        idNo: null,
        email: "",
        jobinfo: "",
        status: 1,
        id: ""
      },
      statusOptions: [],
      resources: {
        resourceCode: "",
        resourceType: 1,
        id: null
      },
      resourcesPage: {
        page: 1,
        size: 10,
        total: 0
      },
      resourceTypeList: [
        { value: 1, label: "按钮" },
        { value: 2, label: "页面" }
      ],
      sts: 0,
      appTypeList: [],
      entryList: [],
      optionList: [],
      total: null,
      title: "添加菜单",
      titleTwo: "查看配置基本信息",
      currentPage: 1,
      form: {
        name: "",
        url: "",
        status: null
      },
      tableData: [],
      page: {
        page: 1,
        size: 10
      },
      formData: {
        menuName: "",
        menuUrl: "",
        status: 0,
        id: null,
        remark: "",
        menuCode: "",
        pid: null,
        appId: "",
        menu: 0,
        orderNo: null,
        menuIcon: ""
      },
      menuType: [{ value: 1, label: "是" }, { value: 0, label: "否" }],
      SelectionChangeList: [],
      roleRreeList: [],
      resourcesFormData: {
        resourceCode: null,
        resourceType: 1,
        remark: "",
        id: null
      },
      isShearch: true,
      pageTwo: {
        page: 1,
        size: 10
      },
      choiceList: [],
      rules: {
        menuName: [
          { required: true, message: "请输入菜单名称", trigger: "blur" }
        ],
        menuUrl: [
          { required: true, message: "请输入菜单路径", trigger: "blur" }
        ],
        // menuCode: [
        //   { required: true, message: '请输入菜单编码', trigger: 'blur' },
        // ],
        menuCode: [
          { required: true, message: "请输入菜单编码", trigger: "blur" },
          {
            // pattern:/^1[3|4|5|7|8][0-9]\d{8}$/,
            pattern: /^[a-zA-Z][^\u3400-\u9FFF]*$/,
            message: "编码不能输入中文且必须以字母开头"
          }
        ],
        resourceCode: [
          { required: true, message: "请输入资源编码", trigger: "blur" }
        ],
        appId: [{ required: true, message: "请选择应用类型", trigger: "blur" }]
      },
      fileList: [],
      props: {
        value: "id",
        label: "label",
        children: "children",
        checkStrictly: true
      }
    };
  },
  mounted() {
    this.queryDictionaries();
    this.st = 1;
    this.getrole();
    this.getApp();
    let prefix = "";
    if (window.location.href.substring(0, 24) == "https://ilh.szlhq.gov.cn") {
      prefix = "aupply-chains-12-30102/";
    }
    this.imgUploadUrl =
      process.env.VUE_APP_API_DOMAIN +
      prefix +
      "tbase-wos-service/wos/api/v1/upload";
  },
  methods: {
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/svg+xml";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG /PNG/svg格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    getExceed() {
      this.$message.error("上传只允许上传一张图片，请先删除当前图片");
    },
    handleRemove(file, fileList) {
      this.fileList = [];
      this.formData.menuIcon = "";
      // console.log(file);
    },
    handlePreview(file) {
      // console.log(file);
    },
    getImgInfo(res) {
      // console.log("res", res);
      if (res.data[0]) {
        this.formData.menuIcon = res.data[0].url;
        let fileObj = {};
        fileObj.name = res.data[0].fileName;
        fileObj.url = res.data[0].url;
        this.fileList.push(fileObj);
      }
    },
    async treeLoadSon(tree, treeNode, resolve) {
      let params = {
        roleCode: this.form.roleCode,
        roleName: this.form.roleName,
        roleType: this.form.roleType,
        page: this.page.page,
        size: this.page.size,
        data: true,
        nodeId: tree.data.id
      };
      const res = await getMenuList(params);
      this.maps.set(tree.id, { tree, treeNode, resolve });
      console.log(this.maps);
      return resolve(res.data.data[0].children);
    },
    // async getUserStatus(){
    //   let params = {
    //     dictType: 'user_status'
    //   }
    //   const res = await userType(params)
    //   if (res. data.code == 200) {
    //     res.data.data.dataList.map((item) => {
    //       item.itemLabel = Number(item.itemLabel)
    //     })
    //     this.statusOptions = res.data.data.dataList
    //   }
    // },
    // 获取应用下拉列表
    async getApp() {
      const res = await getAppArray();
      if (res.data.code == 200) {
        res.data.data.map(item => {
          this.appTypeList.push({
            value: String(item.appId),
            label: item.appName
          });
        });
      }
    },
    editResources(val) {
      this.resourcesFormData.resourceCode = val.resourceCode;
      this.resourcesFormData.resourceType = val.resourceType;
      this.resourcesFormData.remark = val.remark;
      this.resourcesFormData.id = val.id;
      this.innerVisible = true;
    },
    SelectionChangeResources(val) {
      this.SelectionChangeList = val;
    },
    async onresources() {
      this.innerVisible = false;
      let params = {
        resourceCode: this.resources.resourceCode,
        resourceType: this.resources.resourceType,
        id: this.resources.id,
        page: this.resourcesPage.page,
        size: this.resourcesPage.size
      };
      const res = await getMenuResource(params);
      this.resourcesList = res.data.data.dataList;
      this.resourcesPage.total = res.data.data.total;
    },
    async Setresources() {
      let params = {
        resourceCode: this.resourcesFormData.resourceCode,
        resourceType: this.resourcesFormData.resourceType,
        menuId: this.resources.id,
        id: this.resourcesFormData.id,
        remark: this.resourcesFormData.remark
      };
      const res = await setMenuSaveResource(params);
      this.onresources();
    },
    add() {
      this.innerVisible = true;
      this.resourcesFormData.resourceCode = "";
      this.resourcesFormData.resourceType = 1;
      this.resourcesFormData.remark = "";
    },
    async addResources(val) {
      this.UserGroupVisible = true;
      this.resources.id = val.id;
      let params = {
        resourceCode: this.resources.resourceCode,
        resourceType: this.resources.resourceType,
        id: this.resources.id,
        page: this.resourcesPage.page,
        size: this.resourcesPage.size
      };
      const res = await getMenuResource(params);
      this.resourcesList = res.data.data.dataList;
      this.resourcesPage.total = res.data.data.total;
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      if (columnIndex == 2) {
        //指定坐标
        return "width:100%;text-align:center";
      }
    },
    async getrole() {
      const res = await getRoleArray();
      if (res.data.code == 200) {
        res.data.data.map(item => {
          this.roleData.push({ label: item.value, key: item.id });
        });
      }
    },
    roleChange(val) {
      this.formPermission.roleIds = val;
    },
    async relation(val) {
      // this.$axios.get(`/role/user/${val.id}`).then((res) => {
      //   if (res.data.code == 200) {
      //     this.$nextTick((item) => {
      //       res.data.data.map((item) => {
      //         this.roleValue.push(item.id)
      //       })
      //     })
      //   }
      // })
      let params = {
        roleId: val.id
      };
      const res = await setMenuTree(params);
      if (res.data.code == 200) {
        this.havePermIds = [];
        this.roleRreeList = res.data.data;
        res.data.data.map(item => {
          let is = "children";
          if (item.status == 1) {
            this.havePermIds.push(item.uuid);
          }
          if (item.children.length) {
            item.children.map(ites => {
              if (ites.status == 1) {
                this.havePermIds.push(ites.uuid);
              }
              if (ites.children.length) {
                ites.children.map(iteg => {
                  if (iteg.status == 1) {
                    this.havePermIds.push(iteg.uuid);
                  }
                  if (iteg.children.length) {
                    iteg.children.map(iteb => {
                      if (iteb.status == 1) {
                        this.havePermIds.push(iteb.uuid);
                      }
                      if (iteb.children.length) {
                        iteb.children.map(itec => {
                          if (itec.status == 1) {
                            this.havePermIds.push(itec.uuid);
                          }
                        });
                      }
                    });
                  }
                });
              }
            });
          }
        });
      }
      this.formPermission.id = val.id;
      this.isformPermission = true;
    },
    async RoleAuthorization() {
      var addTree = this.$refs.tree.getCheckedNodes();
      var funs = [];
      for (var s = 0; s < addTree.length; s++) {
        funs.push({
          resourceId: addTree[s].id,
          resourceType: addTree[s].type
        });
      }
      let params = {
        roleId: this.formPermission.id,
        resourceList: funs
      };
      const res = await setRoleGrant(params);
      if (res.data.code == 200) {
        this.$message({
          message: "权限分配成功",
          type: "success"
        });
        this.isformPermission = false;
      }
    },
    resetPassword(val) {
      this.passwordVisible = true;
    },
    handleChange(val) {
      this.formData.deptId = val[val.length - 1];
    },
    handleSelectionChange(val) {
      this.choiceList = val;
    },
    // 启用
    async enableMenu() {
      if (!this.choiceList.length) {
        this.$message({
          message: "请选择用户",
          type: "warning"
        });
        return false;
      }
      let ids = [];
      this.choiceList.map(item => {
        ids.push(item.id);
      });
      let params = {
        ids: ids,
        status: 1
      };
      const res = await setMenuSwitch(params);
      if (res.data.code == 200) {
        this.$message({
          message: "启用成功",
          type: "success"
        });
        this.onReset();
      }
    },
    // 禁用用户
    async disableMenu() {
      if (!this.choiceList.length) {
        this.$message({
          message: "请选择用户",
          type: "warning"
        });
        return false;
      }
      let ids = [];
      this.choiceList.map(item => {
        ids.push(item.id);
      });
      let params = {
        ids: ids,
        status: 0
      };
      const res = await setMenuSwitch(params);
      if (res.data.code == 200) {
        this.$message({
          message: "禁用成功",
          type: "success"
        });
        this.onReset();
      }
    },
    GetUser(val) {
      this.viewFormData.status = val.status;
      this.viewFormData.accountName = val.accountName;
      this.viewFormData.userName = val.userName;
      this.viewFormData.password = val.password;
      this.viewFormData.deptId = val.deptId;
      this.viewFormData.mail = val.mail;
      this.viewFormData.idNo = val.idNo;
      this.viewFormData.phone = val.phone;
      this.viewFormData.userType = val.userType;
      this.viewFormData.jobinfo = val.jobinfo;
      this.visible = true;
    },
    async getValueDialog(num, val) {
      this.iscode = true;
      if (val.pid == -1) {
        this.sts = 0;
        this.isMenu = true;
      } else {
        this.isMenu = false;
        this.sts = 1;
      }
      if (val.data.menu == true) {
        this.formData.menu = 1;
      } else if (val.data.menu == false) {
        this.formData.menu = 0;
      }
      this.dialogVisible = true;
      this.title = "编辑菜单信息";
      this.formData.menuCode = val.data.menuCode;
      this.formData.appId = val.data.appId;
      this.formData.menuName = val.data.menuName;
      this.formData.menuUrl = val.data.menuUrl;
      this.formData.orderNo = val.data.orderNo;
      this.formData.menuIcon = val.data.menuIcon;
      this.fileList = [];
      if (val.data.menuIcon) {
        let fileObj = {};
        fileObj.name = "";
        fileObj.url = val.data.menuIcon;
        this.fileList.push(fileObj);
      }
      if (val.data.status == false) {
        this.formData.status = 0;
      } else {
        this.formData.status = 1;
      }

      this.formData.id = val.id;
      this.formData.remark = val.data.remark;
    },
    // 删除菜单
    async deleteType(val) {
      if ((this.total - 1) % this.page.size === 0) {
        if (this.page.page > 1) {
          this.page.page -= 1;
        }
      }
      this.$axios
        .delete(`${process.env.VUE_APP_API_DOMAIN}/tbase-iam-manage/menu/delete/${val.id}`)
        .then(res => {
          if (res.data.code == 200) {
            this.queryDictionaries();
            // if (val.pid != -1) {
            //   let { tree, treeNode, resolve } = this.maps.get(val.pid);
            //   this.$set(
            //     this.$refs.LoadTable.store.states.lazyTreeNodeMap,
            //     val.pid,
            //     []
            //   );
            //   if (tree) {
            //     this.treeLoadSon(tree, treeNode, resolve);
            //   }
            // } else {

            // }
          } else {
            this.$message({
              message: `${res.data.msg}`,
              type: "warning"
            });
          }
        });
    },
    // // 删除菜单资源
    async deleteResources() {
      if (!this.SelectionChangeList.length) {
        this.$message({
          message: "请选择菜单资源",
          type: "warning"
        });
        return false;
      }
      let list = [];
      this.SelectionChangeList.map(item => {
        list.push(item.id);
      });
      let params = {
        id: this.resources.id,
        resourceIds: list
      };
      const res = await setMenuDeleteResource(params);
      if (res.data.code == 200) {
        this.$message({
          message: "删除成功",
          type: "success"
        });
        this.onresources();
      }
    },
    async cancelcerat() {
      let xx = true;
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          xx = true;
        } else {
          xx = false;
        }
      });
      if (xx == false) {
        this.$message({
          message: "请输入或选择必填项",
          type: "warning"
        });
        return false;
      }
      if (this.sts == 0) {
        let params = {
          menuName: this.formData.menuName,
          menuUrl: this.formData.menuUrl,
          menuCode: this.formData.menuCode,
          status: this.formData.status,
          id: this.formData.id,
          remark: this.formData.remark,
          menu: this.formData.menu,
          appId: this.formData.appId,
          orderNo: Number(this.formData.orderNo),
          menuIcon: this.formData.menuIcon
        };
        const res = await setMenuSave(params);
        if (res.data.code == 200) {
          this.formData.menuName = null;
          this.formData.menuUrl = null;
          this.formData.status = 1;
          this.formData.menuCode = "";
          this.formData.id = null;
          this.formData.pid = null;
          this.formData.remark = "";
          this.formData.appId = "";
          this.formData.orderNo = null;
          this.formData.menuIcon = "";
          this.queryDictionaries();
          this.dialogVisible = false;
          this.$message({
            message: "编辑成功",
            type: "success"
          });
        } else {
          this.$message({
            message: `${res.data.msg}`,
            type: "warning"
          });
        }
      } else {
        let params = {
          appId: this.formData.appId,
          menuName: this.formData.menuName,
          menuUrl: this.formData.menuUrl,
          menuCode: this.formData.menuCode,
          status: this.formData.status,
          id: this.formData.id,
          remark: this.formData.remark,
          menu: this.formData.menu,
          pid: this.formData.pid,
          orderNo: Number(this.formData.orderNo),
          menuIcon: this.formData.menuIcon
        };
        const res = await setMenuSave(params);
        if (res.data.code == 200) {
          if (this.formData.pid != -1) {
            if (this.maps.get(this.formData.pid) !== undefined) {
              if (this.formData.pid) {
                let { tree, treeNode, resolve } = this.maps.get(
                  this.formData.pid
                );
                this.$set(
                  this.$refs.LoadTable.store.states.lazyTreeNodeMap,
                  this.formData.pid,
                  []
                );
                if (tree) {
                  this.treeLoadSon(tree, treeNode, resolve);
                }
              }
            }
          }
          this.formData.menuName = null;
          this.formData.menuUrl = null;
          this.formData.status = 1;
          this.formData.menuCode = "";
          this.formData.id = null;
          this.formData.pid = null;
          this.formData.appId = "";
          this.formData.remark = "";
          this.formData.orderNo = "";
          this.queryDictionaries();
          this.dialogVisible = false;
          this.$message({
            message: "保存成功",
            type: "success"
          });
        } else {
          this.$message({
            message: `${res.data.msg}`,
            type: "warning"
          });
        }
      }
    },
    getchildeditDialog(num, val) {
      this.iscode = false;
      if (num == 0) {
        this.title = "添加菜单";
        this.isMenu = true;
        this.formData.menu = 0;
      } else {
        this.title = "添加子菜单";
        this.isMenu = false;
        this.formData.menu = 1;
      }

      this.sts = num;
      this.formData.pid = null;
      this.formData.appId = "";
      if (num == 1) {
        this.formData.pid = val.id;
        this.formData.appId = val.appId;
      }
      this.formData.menuName = null;
      this.formData.orderNo = null;
      this.formData.menuUrl = null;
      this.formData.status = 1;
      this.formData.id = null;
      this.formData.menuCode = "";
      this.formData.remark = "";
      this.dialogVisible = true;
    },
    handleSizeChange(val) {
      this.page.size = val;
      if (this.isShearch == true) {
        this.queryDictionaries();
      } else {
        this.queryDictionaries("search");
      }
    },
    handleCurrentChange(val) {
      this.page.page = val;
      if (this.isShearch == true) {
        this.queryDictionaries();
      } else {
        this.queryDictionaries("search");
      }
    },
    handleSizeChangeOne(val) {
      this.resourcesPage.size = val;
      this.onresources();
    },
    handleCurrentChangeOne(val) {
      this.resourcesPage.page = val;
      this.onresources();
    },
    // 查询字典类型列表
    onSearch() {
      this.page.page = 1;
      this.page.Size = 10;
      this.currentPage = 1;
      this.isShearch = false;
      this.queryDictionaries("search");
    },
    onReset() {
      this.form.name = "";
      this.form.url = "";
      this.form.status = null;
      this.page.page = 1;
      this.page.size = 10;
      this.currentPage = 1;
      this.isShearch = true;
      this.queryDictionaries();
    },
    // 查询用户列表
    async queryDictionaries(val) {
      let params = {
        menuName: this.form.name,
        menuUrl: this.form.url,
        status: this.form.status,
        data: true,
        page: this.page.page,
        size: this.page.size,
        pid: -1
      };
      if (val) {
        params.pid = "";
      } else {
        params.pid = -1;
      }
      const res = await getMenuRoot(params);
      if (res.data.code == 200) {
        this.tableData = res.data.data.dataList ? res.data.data.dataList : [];
        this.total = res.data.data.total ? Number(res.data.data.total) : 0;
      }
    },
    handleSelect(selection, row) {
      if (row.children) {
        // 这个是父节点取消勾选的情况，将所有子节点全部取消勾选
        let allSelected = row.children.every(child =>
          selection.includes(child)
        );
        if (allSelected) {
          // 如果所有子节点都被勾选，则全部取消勾选
          row.children.forEach(child => {
            this.$refs.LoadTable.toggleRowSelection(child), false;
          });
        } else {
          row.children.forEach(child => {
            // 如果没有被勾选就勾选
            if (!selection.includes(child)) {
              this.$refs.LoadTable.toggleRowSelection(child);
            }
          });
        }
      } else if (row.pid) {
        // 如果是子节点且有父节点，则判断是否勾选父节点
        const parent = this.tableData.find(item => item.id === row.pid);
        if (parent) {
          // 判断是否所有子节点都被勾选
          const allChildrenSelected = parent.children.every(child =>
            selection.includes(child)
          );
          if (allChildrenSelected) {
            // 如果所有子节点都被勾选，则勾选父节点
            this.$refs.LoadTable.toggleRowSelection(parent);
          } else {
            // 否则，取消勾选父节点
            this.$refs.LoadTable.toggleRowSelection(parent, false);
          }
        }
      }
    },
    selectAll(selection) {
      console.log(selection);
      // 根据勾选状态判断是否勾选或取消勾选所有子节点
      this.tableData.forEach(row => {
        if (!row.children || row.children.length === 0) {
          return;
        }

        // 取消勾选所有子节点，不管之前是否有取消勾选过的子节点
        row.children.forEach(child => {
          this.$refs.LoadTable.toggleRowSelection(child, false);
        });

        if (selection.includes(row)) {
          // 勾选父节点时，勾选所有子节点
          row.children.forEach(child => {
            this.$refs.LoadTable.toggleRowSelection(child);
          });
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
.box-father {
  height: 100%;
  width: 100%;
  padding: 0px 20px 20px 20px;
  background-color: #fff;
}
.box-header {
  width: 100%;
  height: 50px;
  display: flex;
  background-color: #fff;
  align-items: center;
  border-bottom: 1px solid #d8d8d8;
}
.box-header-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
.box-header-left-text {
  width: 120px;
  height: 14px;
  font-size: 14px;
  font-family: SourceHanSansCN-Regular, SourceHanSansCN;
  font-weight: 400;
  color: #b2b3c9;
  line-height: 21px;
  display: flex;
  align-items: center;
}
.box-header-right {
  font-weight: 400;
  color: #004ad1;
  line-height: 21px;
  width: 90%;
  height: 81%;
  margin-top: 3px;
  display: flex;
  align-items: center;
}
.section {
  height: 94.9%;
  background-color: #fff;
}
.el-menu-item.is-active {
  background: rgb(59, 121, 203, 0.2) !important;
}
.el-menu-item:hover {
  color: #1e90ff;
}
.daohang {
  display: flex;
  margin-left: 15px;
}
.daohang .el-menu-item {
  width: 100px;
  margin-left: 20px;
}
.biaodan {
  width: 100%;
  margin-top: 1px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 70px;
  .form-item {
    padding: 0;
    margin: 0;
  }
}
.biaodan-left {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.biaodan-left .el-form-item {
  margin-bottom: 0px;
}
.demo-form-inline {
  height: 100%;
  display: flex;
  //align-items: center;
  justify-content: space-between;
}
.export {
  width: 15%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}
/* .aside{
  height: 100%;
}
.disTable{
  height: 100%;
} */
.element.style {
  height: 570px;
}
/* .el-tabs__header {
  padding: 0;
  position: relative;
  margin: 0 0 -28px !important;
} */
///deep/ .el-tabs__item {
//  height: 45px !important;
//  margin-top: 15px;
//}
.form-box {
  width: 100%;
  //display: flex;
  //flex-wrap: wrap;
  margin-top: 10px;
}
.form-content {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.form-item {
  display: flex;
  justify-content: left;
}
.form-content-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
/deep/ ::-webkit-scrollbar-thumb {
  background-color: #dbdde3;
  border-radius: 5px;
}
.botton-box {
  width: 20%;
  height: 50px;
  display: flex;
  align-items: center;
}
.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}
//.el-form--inline .el-form-item__content {
//  width: 70%;
//}
.section .el-form-item__label {
  text-align: left;
}

.addValueDialog .el-form--inline .el-form-item {
  width: 100%;
}
.black {
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
/deep/ .el-dialog__wrapper .addValueDialog .el-form-item__label {
  width: 130px !important;
}
.info input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #606266;
}
.passWordForm {
  .el-form-item__content {
    width: 70%;
    display: flex !important;
    justify-content: space-between;
    align-items: baseline;
    margin-top: -43px;
    margin-left: 95px;
  }
}

.updatePassword {
  width: 70px;
  height: 36px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background: #0495FF;
  border-radius: 10%;
}
#character {
  .el-dialog {
    height: 860px;
    overflow: scroll;
  }

  .el-form-item__label {
    width: 95px;
  }

  .Permission_form {
    display: flex;
    justify-content: space-around;
    .roleLabel {
      color: #606266;
      font-size: 14px;
      font-weight: 800;
    }
    .el-form-item__content {
      width: 78.5%;
      height: 45px;
    }
  }

  .div-tag {
    width: auto;
    display: inline-block;
    position: relative;
    bottom: 41px;
    left: 4px;
    height: 40px;
    max-width: 450px;
    overflow-y: hidden;
    overflow-x: scroll;
    white-space: nowrap;
  }

  .test-1::-webkit-scrollbar {
    /*滚动条整体样式*/
    width: 10px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 5px;
  }

  .test-1::-webkit-scrollbar-thumb {
    /*滚动条里面小方块*/
    border-radius: 10px;
    box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #ccc;
  }

  .character .el-dialog__body .data-d {
    height: 345px;
  }
  .pass {
    .el-dialog {
      margin-top: 33vh !important;
      width: 23% !important;
      height: 433px !important;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
    }
  }
}
/deep/.v-modal {
  z-index: 2000 !important;
}
.user-dialog {
  .el-form-item {
    margin-bottom: 10px;
    width: 45% !important;
  }
}
.character .el-dialog__body form {
  padding-bottom: 0;
}
.tree-option {
  height: auto;
}
.tree-class .el-tree-node__content {
  &:hover {
    background-color: #dfeafb;
  }
}
.el-message {
  z-index: 2222 !important;
}
.tree-d {
  .el-form-item__content {
    position: relative;
    & > .el-input {
      position: absolute;
      z-index: 2;
    }
  }
}
.word {
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    margin-left: 25px;
  }
}
.guanlian {
  margin-left: 88px;
}
///deep/ .table_name {
//  table {
//    tbody {
//      tr {
//        td:nth-child(3) {
//          text-align: left;
//          display: flex;
//        }
//      }
//    }
//  }
//}
/deep/ .table_name {
  table {
    tbody {
      tr {
        td:nth-child(2) .cell {
          display: flex;
          align-items: center;
        }
      }
    }
  }
}
///deep/.table_name .cell{
//  display: flex;
//  //align-items: center;
//  //height: 30px;
//  //text-align: center;
//}
.Group-button {
  margin-bottom: 15px;
}
.aside .el-button {
  padding: 0;
}
@media screen and (max-width: 1855px) {
  .biaodan {
    height: 100px;
  }
}
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}
/deep/ .el-upload__input {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/AuthenticationAuthority/menuManagement/index.vue